import styles from './small-width-container.module.less';

const SmallWidthContainer = ({ className = '', children }) => (
    <div className={[className, styles.container].join(' ')}>{children}</div>
);

export default SmallWidthContainer;
